import clsx from 'clsx';
import { useEffect, useRef } from 'react';

import * as styles from './TrustpilotStars.module.css';

const kindOptions = {
  mini: '53aa8807dec7e10d38f59f32',
  horizontal: '5406e65db0d04a09e042d5fc',
  micro: '5419b637fa0340045cd0c936',
};

type Kind = keyof typeof kindOptions;

type Props = {
  className?: string;
  kind?: Kind;
  width?: string;
  height?: string;
  locale: string;
};

declare global {
  interface Window {
    Trustpilot?: { loadFromElement: (element?: HTMLElement, forceReload?: boolean) => void };
  }
}

export const TrustpilotStars = ({
  className,
  locale,
  kind = 'mini',
  width = '235px',
  height = '110px',
}: Props): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.addEventListener('load', () => {
      window.Trustpilot?.loadFromElement(ref.current!, true);
    });
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    document.body.appendChild(script);
  }, [locale]);

  return (
    <div
      ref={ref}
      className={clsx(styles.wrapper, className)}
      data-locale={locale}
      data-template-id={kindOptions[kind]}
      data-businessunit-id='64576da60193dd434c83a77d'
      data-style-height={height}
      data-style-width={width}
      data-theme='light'
      data-text-color='#111111'
    />
  );
};
